import React, { memo } from 'react'
import { Typography } from '@mui/material'
import { ClockMajor } from '@shopify/polaris-icons'
import tw from 'twin.macro'

const RecollectionUnderReviewPillComponent = () => {
  return (
    <div css={tw`flex items-center justify-center gap-2 py-2 px-4 rounded-lg bg-info-200 w-full`}>
      <ClockMajor width={16} height={16} css={tw`fill-info-500`} />
      <Typography variant="body1" css={tw`text-info-500`}>
        New submission under review
      </Typography>
    </div>
  )
}

export const RecollectionUnderReviewPill = memo(RecollectionUnderReviewPillComponent)
